import { contractCategoryBlock } from './ContractCategoryBlock';

export default contractCategoryBlock;
